/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_ConfirmInputs */

const en_admin_invite_codes_delete_confirm = /** @type {(inputs: Admin_Invite_Codes_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const zh_admin_invite_codes_delete_confirm = /** @type {(inputs: Admin_Invite_Codes_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Admin_Invite_Codes_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_confirm = /** @type {((inputs?: Admin_Invite_Codes_Delete_ConfirmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_ConfirmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_delete_confirm(inputs)
	return zh_admin_invite_codes_delete_confirm(inputs)
});
export { admin_invite_codes_delete_confirm as "admin.invite_codes.delete_confirm" }